import "./ProductContent.scss";
import "./ProductContentMobile.scss";

import PPCSideBar from "./PPCSideBar/PPCSideBar";
import PPCMainContent from "./PPCMainContent/PPCMainContent";

import React, { useState, useEffect } from "react";
import { FaFilter, FaSearch, FaBars } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

function ProductContent() {
  const [filterData, setFilterData] = useState([]);
  const [sortVal, setSortVal] = useState("newest");
  const [restoredPageData, setRestoredPageData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(false);

  const { state } = useLocation();
  const sortValFromSeeMore = state?.sortVal || sortVal;

  useEffect(() => setSortVal(sortValFromSeeMore), [sortValFromSeeMore]);

  return (
    <>
      <section className="ppc-container">
        {/* HEADER */}
        <div className="ppc-header">
          {/* Mobile filter button */}
          <span
            className="filter"
            onClick={() => setMobileSidebarOpen(true)}
            title="Filter"
          >
            <span>FILTER</span>
            <FaFilter />
          </span>
          <div className="sort-container">
            <div className="search-wrapper">
              <FaSearch className="search-icon" />
              <input
                type="text"
                className="search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="sort-by">
              <label htmlFor="sort">SORT BY: </label>
              <select
                id="sort"
                value={sortVal}
                onChange={(e) => setSortVal(e.target.value)}
              >
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
                <option value="lowest-price">Lowest price</option>
                <option value="highest-price">Highest price</option>
                <option value="most-popular">Most Popular</option>
              </select>
            </div>
          </div>
        </div>

        {/* MOBILE SIDEBAR (slide menu) */}
        <aside
          className={`ppc-sidebar-mobile ${mobileSidebarOpen ? "open" : ""}`}
        >
          <div
            className="mobile-overlay"
            onClick={() => setMobileSidebarOpen(false)}
          ></div>

          <div className="mobile-sidebar-panel">
            <PPCSideBar setFilterData={setFilterData} filterData={filterData} />
          </div>
        </aside>

        {/* MAIN LAYOUT */}
        <div className="ppc-main-container">
          <aside
            className={`ppc-sidebar-desktop ${
              desktopCollapsed ? "collapsed" : ""
            }`}
          >
            <PPCSideBar setFilterData={setFilterData} filterData={filterData} />
          </aside>

          <main className="ppc-main-content">
            <PPCMainContent
              filterData={filterData}
              setFilterData={setFilterData}
              sortVal={sortVal}
              searchTerm={searchTerm}
            />
          </main>
        </div>
      </section>
    </>
  );
}

export default ProductContent;
